import { Component, OnInit, Input } from '@angular/core';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { EquipmentActionHistory, ActionType } from '../../models/manage-equipment.model';

import moment from 'moment';



import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MY_FORMATS } from '../../../../modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { Sort } from '@angular/material/sort';
import { COstEditPopupComponent } from './cost-edit-popup/cost-edit-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { CryptoService } from '../../../../services/crypto.service';
import { ActionEditComponent } from '../../../equipment-record-action/component/action-edit/action-edit.component';



@Component({
  selector: 'app-action-history',
  templateUrl: './action-history.component.html',
  styleUrls: ['./action-history.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ActionHistoryComponent implements OnInit {
  @Input() equipmentId: number;
  @Input() eqName: string;
  @Input() EnableDistTravelledTracking: boolean;
    @Input() ShowPropelHrsPerc: boolean;
  actionHistoryList: EquipmentActionHistory[]
  actionTypeList: ActionType[]
  componentTypesList: string[]
  componentType: string;
  side: string;
  sideList: string[]
  startDate: Date;
  endDate: Date;
  userCurrency: string;
  totalCost: number;

  ActionDesc:boolean=true;
SMU:boolean=true;
LTD:boolean=true;
DOE:boolean=true;
LhChain:boolean=true;
RhChain:boolean=true;
Side:boolean=true;
Pos:boolean=true;
ActionDescCol:boolean=true;
Comment:boolean=true;
EnteredBy:boolean =true;
EnteredDate:boolean=true;
JobSite:boolean=true;

  actionTypeAuto: number;
  // myControl: FormControl = new FormControl();

  sortedData;
  userUOD: string = 'km';
  hasLastAction: boolean = false;
  allowEditAction: boolean = false;

  refreshList() {

    console.log("actionHistoryList", this.actionHistoryList)

    this.sortedData = this.actionHistoryList.slice()
    this.actionTypeAuto = 0
    this.side = ""
    this.componentType = ""
    let totalCost_ = 0
    let arrStartDates = []
    let arrEndDates = []

    this.actionHistoryList.map(m => {
      //totalCost_ = totalCost_ + m.LabourCost + m.PartsCost + m.MiscCost;
      totalCost_ = totalCost_ + m.cost
      m['entry_date'] = moment(m.entry_date).format('DD MMMM YYYY')
      m['event_date'] = moment(m.event_date).format('DD MMMM YYYY')

      arrStartDates.push(new Date(m.event_date))
      arrEndDates.push(new Date(m.entry_date))
    })

    //get min/max date
    let minDate = new Date(Math.min.apply(null, arrStartDates))
    let maxDate = new Date(Math.max.apply(null, arrEndDates))

    this.startDate = minDate;
    this.endDate = maxDate;

    this.totalCost = totalCost_
  }

  constructor(private _equipmentService: ManageEquipmentService,private _dialog: MatDialog, private readonly _pref: PreferencesService, private crypto: CryptoService) {

  }

  ngOnInit() {
    this.loadEquipmentsActionHistory();
    this.getUserUOD();
  }


  sortData(sort: Sort) {
    const data = this.actionHistoryList.slice();
    if (!sort.active || sort.direction == '') {
      this.sortedData = data;
      return;
    }



    this.sortedData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'actionDate': return compare(a.event_date, b.event_date, isAsc);
        case 'actionDesc': return compare(a.action_name, b.action_name, isAsc);
        case 'comment': return compare(a.comment, +b.comment, isAsc);
        case 'smu': return compare(+a.equipment_smu, +b.equipment_smu, isAsc);
        case 'ltd': return compare(a.equipment_ltd, +b.equipment_ltd, isAsc);
        //case 'side': return compare(a.side, b.side, isAsc);
        //case 'pos': return compare(+a.Pos, +b.Pos, isAsc);
        case 'enteredBy': return compare(a.entry_user_name, b.entry_user_name, isAsc);
        case 'enteredDate': return compare(a.entry_date, b.entry_date, isAsc);
        // case 'labourCost': return compare(+a.LabourCost, +b.LabourCost, isAsc);
        // case 'partCost': return compare(+a.PartsCost, +b.PartsCost, isAsc);
        // case 'miscCost': return compare(+a.MiscCost, +b.MiscCost, isAsc);
        case 'totalCost': return compare(+a.totalCost, +b.totalCost, isAsc);
        case 'ActionJobsite': return compare(+a.ActionJobsite, +b.ActionJobsite, isAsc);
        default: return 0;
      }
    });
  }
  //_tableSortDec = 'asc'
  //_header = 1;
  //changeArrow(val){
  //  if(val==this._header){
  //    if(this._tableSortDec == "asc"){
  //      return "headerSortUp"
  //    }else{
  //      return "headerSortDown"
  //    }
  //  }else{
  //    return ""
  //  } 
    
  //}

  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  changeArrow(val) {
    if (val == this.sortColumn) {
      if (this.sortDirection == "asc") {
        return "headerSortUp"
      } else {
        return "headerSortDown"
      }
    } else {
      return ""
    }
  }

  sortTable(column: string) {
    if (this.sortColumn === column) {
      // toggle sort direction
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.sortedData.sort((a, b) => {
      let aVal = a[column];
      let bVal = b[column];

      // Normalize empty strings to null
      aVal = aVal == null || aVal === '' ? '-1' : aVal;
      bVal = bVal == null || bVal === '' ? '-1' : bVal;

      // Handle null or undefined
      //if (aVal == null) return -1;
      //if (bVal == null) return -1;

      // Check if value is a valid date
      const aDate = new Date(aVal);
      const bDate = new Date(bVal);

      const isADate = !isNaN(aDate.getTime());
      const isBDate = !isNaN(bDate.getTime());

      if (isADate && isBDate) {
        return this.sortDirection === 'asc'
          ? aDate.getTime() - bDate.getTime()
          : bDate.getTime() - aDate.getTime();
      }

      // Try to parse as numbers
      const aNum = parseFloat(aVal);
      const bNum = parseFloat(bVal);

      const isANumber = !isNaN(aNum);
      const isBNumber = !isNaN(bNum);

      if (isANumber && isBNumber) {
        return this.sortDirection === 'asc' ? aNum - bNum : bNum - aNum;
      }

      // Fallback: treat as strings
      const aStr = String(aVal).toLowerCase();
      const bStr = String(bVal).toLowerCase();

      return this.sortDirection === 'asc'
        ? aStr.localeCompare(bStr)
        : bStr.localeCompare(aStr);
    });
  }
  //sortTable(n) {
  //  this._header = n;
  //  var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
  //  table = document.getElementById("historyTable");
  //  switching = true;
  //  // Set the sorting direction to ascending:
  //  dir = "asc";

  //  this._tableSortDec = dir

  //  /* Make a loop that will continue until
  //  no switching has been done: */
  //  while (switching) {
  //    // Start by saying: no switching is done:
  //    switching = false;
  //    rows = table.rows;
  //    /* Loop through all table rows (except the
  //    first, which contains table headers): */
  //    for (i = 1; i < (rows.length - 1); i++) {
  //      // Start by saying there should be no switching:
  //      shouldSwitch = false;
  //      /* Get the two elements you want to compare,
  //      one from current row and one from the next: */
  //      x = rows[i].getElementsByTagName("TD")[n];
  //      y = rows[i + 1].getElementsByTagName("TD")[n];
  //      /* Check if the two rows should switch place,
  //      based on the direction, asc or desc: */
  //      if (dir == "asc") {
  //        if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
  //          // If so, mark as a switch and break the loop:
  //          shouldSwitch = true;
  //          break;
  //        }
  //      } else if (dir == "desc") {
  //        if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
  //          // If so, mark as a switch and break the loop:
  //          shouldSwitch = true;
  //          break;
  //        }
  //      }
  //    }
  //    if (shouldSwitch) {
  //      /* If a switch has been marked, make the switch
  //      and mark that a switch has been done: */
  //      rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
  //      switching = true;
  //      // Each time a switch is done, increase this count by 1:
  //      switchcount ++;
  //    } else {
  //      /* If no switching has been done AND the direction is "asc",
  //      set the direction to "desc" and run the while loop again. */
  //      if (switchcount == 0 && dir == "asc") {
  //        dir = "desc";
  //  this._tableSortDec = dir

  //        switching = true;
  //      }
  //    }



  //  }
  //}



  //get action type picker select
  filterByActionType() {
    let arrActionHistory = []
    let totalCost_ = 0
    this.sortedData = this.actionHistoryList.slice();
    this.sortedData.map(a => {
      if (a.action_type_auto == this.actionTypeAuto) {
        //totalCost_ = totalCost_ + a.LabourCost + a.PartsCost + a.MiscCost;
        totalCost_ = totalCost_ + a.cost;
        arrActionHistory.push(a)
      }
    })
    this.totalCost = totalCost_
    this.sortedData = arrActionHistory.slice()
  }

  //filter by component Type
  filterByComponentType() {
    let arrActionHistory = []
    let totalCost_ = 0
    this.sortedData = this.actionHistoryList.slice();
    this.sortedData.map(a => {
      if (a.CompType && a.CompType == this.componentType) {
        //totalCost_ = totalCost_ + a.LabourCost + a.PartsCost + a.MiscCost;
        totalCost_ = totalCost_ + a.cost;
        arrActionHistory.push(a)
      }
    })
    this.totalCost = totalCost_
    this.sortedData = arrActionHistory.slice()
  }

  //Filter by side
  filterBySide() {
    let arrActionHistory = []
    let totalCost_ = 0;
    this.sortedData = this.actionHistoryList.slice();
    this.sortedData.map(a => {
      let side_ = a.side != null ? a.side == 1 || a.side == "Left" ? "Left" : a.side == 2 || a.side == "Right" ? "Right" : "" : ""
      if (side_ && side_ == this.side) {
        //totalCost_ = totalCost_ + a.LabourCost + a.PartsCost + a.MiscCost;
        totalCost_ = totalCost_ + a.cost;
        arrActionHistory.push(a)
      }
    })
    this.totalCost = totalCost_
    this.sortedData = arrActionHistory.slice()
  }
  EditComponentData(item) {
    const dialogRef = this._dialog.open(COstEditPopupComponent, {
      width: '950px',
      maxHeight: '950px',
      data: {
        HistoryId: item,
      },
      disableClose: true
    });
  
    dialogRef.afterClosed().subscribe(changed => {
      if (changed) {
        this.loadEquipmentsActionHistory();
      }
    });
  }
  
  //start date picker
  StartDateChange(event) {
    this.startDate = event.value
    let arrActionHistory = []
    let totalCost_ = 0
    this.sortedData = this.actionHistoryList.slice();
    this.sortedData.map(m => {
      if (
        (new Date(m.event_date) >= event.value) &&
        (new Date(m.event_date) <= this.endDate)
      ) {
        //totalCost_ = totalCost_ + m.LabourCost + m.PartsCost + m.MiscCost;
        totalCost_ = totalCost_ + m.cost;
        arrActionHistory.push(m)
      }
    })
    //console.log("arrActionHistory ", arrActionHistory)
    this.totalCost = totalCost_
    this.sortedData = arrActionHistory.slice()
  }

  //End date picker
  EndDateChange(event) {
    this.endDate = event.value
    let arrActionHistory = []
    let totalCost_ = 0
    this.sortedData = this.actionHistoryList.slice();
    this.sortedData.map(m => {
      if (  new Date(m.event_date) <= event.value && new Date(m.event_date) >= this.startDate) {
        totalCost_ = totalCost_ + m.cost;
        arrActionHistory.push(m)
      }
    })
    this.totalCost = totalCost_
    this.sortedData = arrActionHistory.slice()
  }

  DownloadCSVFile() {
    this.downloadFile(this.sortedData)
  }

  //download csv file
  downloadFile(data: any) {

    console.log("data", data)

   

    let _data = []

    data.map(p => {
      let _o = {}
      for (var key in p) {
        if (p.hasOwnProperty(key)) {

          if(key == "entry_date"){
            _o["Action Date"] = p[key]
          }else if(key == "action_name"){
            _o["Action Desc"] = p[key]
          }else if(key == "comment"){
            _o["Comment"] = p[key]
          }else if(key == "equipment_smu"){
            _o["SMU/Horomenter"] = p[key]
          }else if(key == "equipment_ltd"){
            _o["LTD"] = p[key]
          }else if(key == "side"){
            _o["Side"] = p[key]
          }else if(key == "pos"){
            _o["Pos"] = p[key]
          }else if(key == "entry_user_name"){
            _o["Entered by"] = p[key]
          }else if(key == "event_date"){
            _o["Entered Date"] = p[key]
          }else if(key == "LabourCost"){
            _o["Labour"] = p[key]
          }else if(key == "PartsCost"){
            _o["Part"] = p[key]
          }else if(key == "MiscCost"){
            _o["Misc"] = p[key]
          }else if(key == "totalCost"){
            _o["Total Cost"] = p[key]
          }
        }
    }

    _data.push(_o)
    })

    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(_data[0]);
    let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var a = document.createElement('a');
    var blob = new Blob([csvArray], { type: 'text/csv' }),
      url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = `ActionHistory_SN ${this.eqName}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  equipmentActionHistory:EquipmentActionHistory[];

  loadEquipmentsActionHistory = () => {
    let arrActionTypes = []
    let arrStartDates = []
    let arrEndDates = []
    let compartTypeList = []
    let totalCost_ = 0;
    this._equipmentService.getEquipmentActionHistory(this.equipmentId).subscribe(history => {
      history.map(m => {
        if (m.entry_user_name && m.entry_user_name.length > 0) {
          m.entry_user_name = this.crypto.decrypt(m.entry_user_name);
        }
        var action = new ActionType();
        action.action_type_auto = m.action_type_auto;
        action.action_description = m.action_name;
     //   this.calculateRunningCost(m);

        arrActionTypes.push(action)



        let totalcost = m.cost;
        m['totalCost'] = totalcost;
        m['entry_date'] = moment(m.entry_date).format('DD/MMM/YYYY')
        m['event_date'] = moment(m.event_date).format('DD/MMM/YYYY')

        arrStartDates.push(new Date(m.event_date))
        arrEndDates.push(new Date(m.entry_date))

        if (m.CompType) {
          compartTypeList.push(m.CompType)

        }
        totalCost_ = totalCost_ + m.cost;
        this.userCurrency = m.currency

      })


      this.componentType = "";
      this.actionHistoryList = history;

      this.hasLastAction = this.actionHistoryList?.some(
        x => x.IsLastAction === true
      );
      this.allowEditAction = this.actionHistoryList?.some(
        x => x.AllowEditAction === true
      );

      console.log("history__", history)

      this.actionTypeList = arrActionTypes.filter((thing, index, self) =>
        index === self.findIndex((t) => (
          //t.place === thing.place && 
          t.action_type_auto === thing.action_type_auto
        ))
      )
      this.componentTypesList = compartTypeList
      this.sideList = ["Left", "Right"]
      this.sortedData = this.actionHistoryList.slice();
      this.totalCost = totalCost_
      //get min/max date
      let minDate = new Date(Math.min.apply(null, arrStartDates))
      let maxDate = new Date(Math.max.apply(null, arrStartDates))

     // this.startDate = minDate;
      //this.endDate = maxDate;

      this.startDate = minDate;
      this.endDate = maxDate;

      // console.log("_____EQSYSYSTEM", this.equipmentSystems)



    });
  }

  calculateRunningCost(EquipmentActionHistory:EquipmentActionHistory[] ) {
    let runningCost = 0;
    // Iterate in reverse order
    for (let i = EquipmentActionHistory.length - 1; i >= 0; i--) {
      runningCost += EquipmentActionHistory[i].cost;
      EquipmentActionHistory[i].RunningCost = runningCost; // Store the running cost in the object
    }
  }



ShowHideTableColumn(value: any) {
  switch (value) {
    case 1:
      this.ActionDesc = !this.ActionDesc;
      break;
    case 2:
      this.SMU = !this.SMU;
      break;
    case 3:
      this.LTD = !this.LTD;
      break;
    case 4:
      this.LhChain = !this.LhChain;
      break;
    case 5:
      this.RhChain = !this.RhChain;
      break;
    case 6:
      this.Side = !this.Side;
      break;
      case 7:
      this.Pos = !this.Pos;
      break;
    case 8:
      this.ActionDescCol = !this.ActionDescCol;
      break;
    case 9:
      this.Comment = !this.Comment;
      break;
    case 10:
      this.EnteredBy = !this.EnteredBy;
      break;
    case 11:
      this.EnteredDate = !this.EnteredDate;
      break;
    case 12:
      this.JobSite = !this.JobSite;
      break;
      case 13:
        this.DOE = !this.DOE;
        break;
    default:
      console.warn("Invalid value:", value);
      break;
  }

 
}

//TT-9235
 getUserUOD(){
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
   // to convert distance from kilometers to miles for display purpose
 convertDistanceKmToMi(distance: number): number {
  return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }
// showPosition(position: number, compartTypeId: number): string {

//   if (this.equipmentSystems[0].Components.length > 4) {
//     return this.getPositionStringDoubleComponents(position, compartTypeId);
//   } else {
//     return this._app.getPositionString(position, compartTypeId);
//   }

// }

  editAction(data: EquipmentActionHistory) {
    //window.open(`/equipment-record-action/${this.equipmentId}/${data.equipment_smu}/${encodeURIComponent(data.event_date)}/1`, '_blank');
    const addSectionDialog = this._dialog.open(ActionEditComponent, {
      width: '70%',
      height: '80%',
      disableClose: true,
      data: {
        actionId: data.history_id,
        equipmentId: this.equipmentId,
        actionDate: data.event_date,
        actionSMU: data.equipment_smu,
         actionPMU: data.equipment_PMU,
        enableDistTravelledTracking: data.EnableDistTravelledTracking,
        ShowPropelHrsPerc: this.ShowPropelHrsPerc
      }
    });
    addSectionDialog.afterClosed().subscribe(r => {
      if (r) {
        window.location.reload();
      } else {

      }
    });
 

  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

